import React from 'react'

import {ProjectSystemType} from "../../../../../core/model2/project/types"
import AppQuickAdd from "../../../quick-add"
import {templatesLibrary} from "../config/library"
import {BreadcrumbCustomItem} from "../../../../../core/gd-components/breadcrumbs/breadcrumbs-custom"
import {QuickAddItemBreadcrumb} from "../../../@types"
import NewTitleBreadcrumb from "../../../layout/page-title/form-title-breadcrumb"

type Props = {
    app                 : AppQuickAdd
    initParams          : any

    templateId          : ID
    redirected?         : boolean

    onSelectType        : {(type: any, templateId?: ID): void}
    onProjectCreated?   : func
}

// const debug = "NewProject_AddFromSharedTemplate"
const debug = false

export default function NewProject_AddFromSharedTemplate(props: Props) {

    const templateId = props.templateId
    let template: any

    const sharedTemplates = _.clone(templatesLibrary)

    _.map(sharedTemplates, (g:any)=>{
        const found = _.find(g.items, t=>t.id === templateId)
        if (!template && found) {
            template = found
        }
    })

    if (!template) return <div>Error. Tpl not found.</div>

    let AddForm

    switch (template.systemType) {
        case ProjectSystemType.FOLDER   : AddForm = require('../form/from-library/workfolder'); break
        case ProjectSystemType.PROJECT  : AddForm = require('../form/from-library/project'); break
        case ProjectSystemType.SPRINT   : AddForm = require('../form/from-library/sprint'); break
        case ProjectSystemType.BACKLOG  : AddForm = require('../form/from-library/backlog'); break
    }

    const breadcrumbItems: BreadcrumbCustomItem[] = [
        QuickAddItemBreadcrumb.PROJECT_RESOURCES,
        QuickAddItemBreadcrumb.PROJECT_TEMPLATE_LIBRARY,
        {
            label: template.name
        }
    ]

    return (
        <div className={Classes("new-main","new-form","project")}>
            <NewTitleBreadcrumb breadcrumbItems={breadcrumbItems}/>
            <div className="quick-add-content m-t-35">
                <AddForm app                = {props.app}
                         initParams         = {props.initParams}
                         template           = {template}
                         redirected         = {props.redirected}
                         isSharedTemplate   = {true}
                         onProjectCreated   = {props.onProjectCreated}/>
            </div>
        </div>
    )
}
